import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { API_PrivateValuerInfo, BASEURL_POLYMER } from '../../utils/api';
import config from '../../config';

const isProd =
  process.env.NODE_ENV === 'production' &&
  document.location.origin !== 'https://services3-dev.hdb.gov.sg' &&
  document.location.origin !== 'https://services3-stg.hdb.gov.sg';

interface QueryParams {
  applicationUuid: string;
  singpass_token: string;
  uinfin: string;
}

export interface PrivateValuerInfoResponse {
  privateValue: string;
  valuationRequired: string;
}

const baseQuery = fetchBaseQuery({
  baseUrl: BASEURL_POLYMER,
  prepareHeaders: (headers) => {
    headers.set('X-Content-Type-Options', 'nosniff');
    return headers;
  },
});

export const privateValuerInfoApi = createApi({
  reducerPath: 'privateValuerInfoApi',
  baseQuery,
  endpoints: (builder) => ({
    getPrivateValuerInfo: builder.query<PrivateValuerInfoResponse, QueryParams>({
      query: ({ applicationUuid, singpass_token, uinfin }) => ({
        method: 'GET',
        url: API_PrivateValuerInfo,
        params: { applicationUuid },
        headers: {
          Authorization: `Bearer ${singpass_token}`,
          ...(isProd ? {} : { uinfin }),
        },
      }),
      keepUnusedDataFor: 1,
    }),
  }),
});

export const { useGetPrivateValuerInfoQuery } = privateValuerInfoApi;
